import React from "react"
import { RootLayout } from "./src/components"

// Tailwind setup
import "./src/css/index.css"
// import "@gorilla-technologies/corporate-ui/styles.min.css"

export const wrapRootElement = ({ element }) => (
  // eslint-disable-next-line react/jsx-filename-extension
  <RootLayout>{element}</RootLayout>
)
